import {combineReducers} from '@reduxjs/toolkit';
import {userPageSlice} from 'src/modules/profile/user/services/user-page-slice';
import {userPageTabsReducer} from 'src/modules/profile/user/services/user-page-tabs-reducer';
import {assignUserEntitlementsReducer} from 'src/modules/profile/user/tabs/assign-entilements';
import {assignProductUserEntitlementsReducer} from 'src/modules/profile/user/tabs/assign-product-entilements';

export const userPageReducer = combineReducers({
    details: userPageSlice.reducer,
    tabs: userPageTabsReducer,
    assignEntitlements: assignUserEntitlementsReducer,
    assignProductEntitlements: assignProductUserEntitlementsReducer,
});
